module.exports = __webpack_public_path__ + "static/media/Adobe_XD.207a6b48.svg";